export default (event, callback) => {
    event.preventDefault();
    if (event.keyCode === 13) {
        callback()
    }
}